// extracted by mini-css-extract-plugin
export default {"loadingIcon":"loader_loadingIcon__wjxyP","spin":"loader_spin__KVqdy"};